export const adminCommunity = {
  // Community Genealogy Tree Admin Page
  "admin.community.communityGenealogyTree.title": "Community Genealogy Tree",
  "admin.community.communityGenealogyTree.subtitle": "Visualize and explore the complete referral structure",
  "admin.community.communityGenealogyTree.loading": "Loading genealogy tree...",
  "admin.community.communityGenealogyTree.error": "Error loading genealogy tree",
  "admin.community.communityGenealogyTree.searchLabel": "Search by Username",
  "admin.community.communityGenealogyTree.searchPlaceholder": "Enter username...",
  "admin.community.communityGenealogyTree.searchButton": "Load Tree",
  "admin.community.communityGenealogyTree.resetButton": "Reset View",
  "admin.community.communityGenealogyTree.userNotFound": "User not found",
  "admin.community.communityGenealogyTree.searchError": "Error searching for user",
  "admin.community.communityGenealogyTree.invalidUser": "Invalid user specified",
  
  // Tree Node Actions
  "admin.community.treeNode.expand": "Expand",
  "admin.community.treeNode.collapse": "Collapse",
  "admin.community.treeNode.directReferrals": "Direct Referrals",
  "admin.community.treeNode.loading": "Loading...",
  
  // Error Messages
  "admin.community.errors.accessDenied": "Access denied: insufficient permissions",
  "admin.community.errors.userNotFound": "User not found",
  "admin.community.errors.networkError": "Reload Page",
  "admin.community.errors.unexpectedError": "An unexpected error occurred"
};